import object from 'lodash/object'
import Param from './Param'
import moment from 'moment'

class StatisticsHelper {
  /**
   *
   * @type Param[]
   */
  parameters = []

  axis = []

  metrics = []

  getAxisNumber (id) {
    let number = 0

    this.axis.forEach((metric, index) => {
      if (id === metric.id) {
        number = index
      }
    })

    return number
  }

  axisConfig () {
    let configs = []

    this.axis.forEach((metric, index) => {
      let config = {
        title: {
          text: metric.title,
          style: {
            color: '#fff'
          }
        },
        labels: {
          format: '{value} ' + metric.suffix,
          style: {
            color: '#fff'
          }
        },
        gridLineColor: '#595c5e'
      }

      if (index !== 0) {
        config.gridLineWidth = 0
      }

      configs.push(config)
    })

    return configs
  }

  getSeries (data) {
    let series = []

    object.forOwn(data, (value, key) => {
      this.parameters.forEach((param) => {
        if (key === param.getId()) {
          series.push({
            data: value,
            name: param.getTitle(),
            yAxis: param.axisId
          })
        }
      })
    })

    return series
  }

  constructor (checkBoxes, parameters, metrics) {
    this.metrics = metrics

    let axis = []

    this.metrics.forEach((metric) => {
      parameters.forEach((parameter) => {
        /**
         * If this metric already in axis array
         * @type {Object || undefined}
         */
        let sameMetric = axis.find(m => m.id === metric.id)

        if ((metric.id === parameter.metric) && (sameMetric === undefined)) {
          axis.push(metric)
        }
      })
    })

    this.axis = axis

    checkBoxes.forEach((deviceType) => {
      deviceType.boxChildrens.forEach((device) => {
        if (device.status) {
          parameters.forEach((selectedParam) => {
            if (selectedParam.typeId === deviceType.id) {
              let axisId = this.getAxisNumber(selectedParam.metric)
              let param = new Param(device.id, selectedParam.value, axisId, `${device.boxName}: ${selectedParam.title}`)
              this.parameters.push(param)
            }
          })
        }
      })
    })
  }

  queryPrameters () {
    let query = {}

    this.parameters.forEach((param) => {
      if (!object.has(query, param.deviceId)) {
        object.set(query, param.deviceId, [])
      }
      let array = object.get(query, param.deviceId)
      array.push(param.value)
      object.set(query, param.deviceId, array)
    })

    return query
  }

  static calculateBatch (dateFrom, dateTo) {
    let from = moment(dateFrom, 'YYYY-MM-DD HH:mm:ss')
    let to = moment(dateTo, 'YYYY-MM-DD HH:mm:ss')

    let diff = to.diff(from)

    let each = Math.round((diff / 1000 / 60 / 60 / 24) * 0.6923076923)

    if (each > 1) {
      return each
    } else {
      return null
    }
  }

  static formatDevices (devicesData) {
    let formattedDevices = []
    object.forOwn(devicesData, (value, key) => {
      let deviceType = {
        id: parseInt(key),
        color: value[0].deviceTypeColor,
        boxName: value[0].deviceTypeName,
        status: false,
        groupShow: false,
        boxChildrens: []
      }
      value.forEach((device) => {
        deviceType.boxChildrens.push(
          {
            id: device.id,
            boxName: device.name,
            status: false
          }
        )
      })
      formattedDevices.push(deviceType)
    })
    return formattedDevices
  }
}

export default StatisticsHelper
